import React, { useState } from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";

const InputWrapper = styled.div`
  max-width: 380px;
  width: 100%;
  margin: 10px auto;
`;

const InputContainer = styled.div`
  background-color: rgba(255, 255, 255, 0.9);
  height: 55px;
  border-radius: 55px;
  display: grid;
  grid-template-columns: 15% 85%;
  padding: 0 0.4rem;
  position: relative;
  border: ${(props) =>
    props.focused ? "2px solid #0098DB" : "2px solid rgba(255, 255, 255, 0.3)"};
  box-shadow: ${(props) =>
    props.focused
      ? "0 0 5px rgba(0, 152, 219, 0.5)"
      : "0 2px 8px rgba(0, 0, 0, 0.2)"};
  transition: border 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  box-sizing: border-box;
`;

const InputIcon = styled(FontAwesomeIcon)`
  text-align: center;
  color: ${(props) => (props.focused ? "#0098DB" : "#acacac")};
  transition: color 0.3s ease-in-out;
  font-size: 1.1rem;
  align-self: center;
  margin-right: 0.5rem;
  margin-left: 1rem;
`;

const Dropdown = styled.select`
  background: none;
  outline: none;
  border: none;
  line-height: 1;
  font-weight: 600;
  font-size: 1.1rem;
  font-family: "Roboto", sans-serif;
  color: #333;
  width: 100%;
  appearance: none;

  &::placeholder {
    color: #aaa;
    font-weight: 500;
  }
`;

const CountryDropdown = ({ value, onChange, countries }) => {
  const [isFocused, setFocused] = useState(false);

  return (
    <InputWrapper>
      <InputContainer focused={isFocused}>
        <InputIcon focused={isFocused} icon={faLocationDot} />
        <Dropdown
          value={value}
          onChange={onChange}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
        >
          {countries.map((country) => (
            <option key={country} value={country}>
              {country}
            </option>
          ))}
        </Dropdown>
      </InputContainer>
    </InputWrapper>
  );
};

export default CountryDropdown;
